import { render, staticRenderFns } from "./stockroom.vue?vue&type=template&id=d039fc62&scoped=true&"
import script from "./stockroom.vue?vue&type=script&lang=js&"
export * from "./stockroom.vue?vue&type=script&lang=js&"
import style0 from "./stockroom.vue?vue&type=style&index=0&id=d039fc62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d039fc62",
  null
  
)

export default component.exports